<template>
  <v-tooltip bottom >
    <template v-slot:activator="{ on, attrs }">
      <v-chip small v-bind="attrs" v-on="on" >
        <v-icon left small >mdi-information</v-icon>
        <slot></slot>
      </v-chip>
    </template>
    <span v-if="infoText" v-text="infoText" />
  </v-tooltip>
</template>
<script>
export default {
  name: 'HelpChip',
  props: {
    infoText: { type: String, required: true }
  }
}
</script>
